import { Format } from "./types";
const DEG = "\u00B0";
const MIN = "\u2032";
const SEC = "\u2033";
export const getCoordinate = (coordinate) => {
    switch (coordinate.format) {
        case Format.Decimal:
            return `${coordinate.decimalValue}`;
        case Format.DegMin:
            return `${coordinate.decimalValue}${DEG} ${coordinate.minutes}${MIN}`;
        case Format.DegMinSec:
            return `${coordinate.decimalValue}${DEG} ${coordinate.minutes}${MIN} ${coordinate.seconds}${SEC}`;
    }
};
export const getDistance = (distance) => {
    const isMeters = distance < 1000 ? true : false;
    const value = isMeters ? distance.toFixed(2) : (distance / 1000).toFixed(2);
    const unit = isMeters ? "m" : "km";
    return `${value}${unit}`;
};
export const getUrl = (position, comprehensive) => {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set("comprehensive", comprehensive.toString());
    urlSearchParams.set("id", position.identifier);
    urlSearchParams.set("x", getCoordinate(position.coordinates.x));
    urlSearchParams.set("y", getCoordinate(position.coordinates.y));
    const url = new URL(window.location.href);
    url.search = urlSearchParams.toString();
    return url.toString();
};
